export default {
  methods: {
    showNotification(status, msg, duration = 3000) {
      const _self = this;
      const module = {
        info() {
          _self.$toast.info(msg, {
            closeOnClick: true,
            icon: "fas fa-info-circle",
            timeout: duration
          });
        },
        success: function () {
          _self.$toast.success(msg, {
            closeOnClick: true,
            icon: "fas fa-check-circle",
            timeout: duration
          });
        },
        warning: function () {
          _self.$toast.warning(msg, {
            closeOnClick: true,
            icon: "fas fa-exclamation-triangle",
            timeout: duration
          });
        },
        error: function () {
          _self.$toast.error(msg, {
            closeOnClick: true,
            icon: "fas fa-exclamation-circle",
            timeout: duration
          });
        },
      };
      module[status]();
    },
  },
};
